export const AllCategories = [
  {
    name: "Speisekarte",
    id: "Speisekarte",
  },
  {
    name: "Pizza",
    id: "Pizza",
  },
  {
    name: "Salat",
    id: "Salat",
  },
  {
    name: "✚Zutaten",
    id: "✚Zutaten",
  },
  {
    name: "Getränke",
    id: "Getränke",
  },
  {
    name: "Angebote",
    id: "Angebote",
  },
];
